module.exports = __webpack_public_path__ + "static/media/feature1.28eb67d0.png";